import { findLast } from 'lodash';

import { TENANT_DOCS_DESCRIPTIONS, USERS_TYPES } from '../constants';
import { IGuest } from '../ts/user';

export const areGuestDocumentsUploaded = (tenant: IGuest): boolean => {
  const tenantDocuments = tenant.documents;
  const identityDocument = findLast(tenantDocuments, {
    type: 'identity_document',
  });
  const residencyDocument = findLast(tenantDocuments, {
    type: 'other',
    description: TENANT_DOCS_DESCRIPTIONS.RESIDENCE_PERMIT,
  });
  const taxNumber = findLast(tenantDocuments, {
    type: 'tax_number',
  });
  const thirdLastPaycheck = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.THIRD_LAST_PAYCHECK,
  });
  const secondLastPaycheck = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_PAYCHECK,
  });
  const lastPaycheck = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_PAYCHECK,
  });
  const workContract = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.WORK_CONTRACT,
  });
  const secondLastIncomeTaxReturn = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_INCOME_TAX_RETURN,
  });
  const lastIncomeTaxReturn = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_INCOME_TAX_RETURN,
  });
  const bankAccountBalancePenultimate = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.PENULTIMATE_ACCOUNT_STATEMENT,
  });
  const bankAccountBalancePrepenultimate = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.PREPENULTIMATE_ACCOUNT_STATEMENT,
  });
  const bankAccountBalanceLatest = findLast(tenantDocuments, {
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LATEST_ACCOUNT_STATEMENT,
  });
  const universityCertification = findLast(tenantDocuments, {
    type: 'other',
    description: TENANT_DOCS_DESCRIPTIONS.UNIVERSITY_CERTIFICATION,
  });
  const lastPension = tenantDocuments
    ? findLast(tenantDocuments, {
        type: 'proof_of_income',
        description: TENANT_DOCS_DESCRIPTIONS.LAST_PENSION_SLIPS,
      })
    : undefined;
  const secondLastPension = tenantDocuments
    ? findLast(tenantDocuments, {
        type: 'proof_of_income',
        description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_PENSION_SLIPS,
      })
    : undefined;

  const areAllDocumentsUploaded = () => {
    const areIdentityDocumentsUploaded = identityDocument && identityDocument;

    const occupation = tenant?.user_occupation ?? tenant?.occupation;
    if (occupation === USERS_TYPES.ITALIAN_STUDENT)
      return (
        areIdentityDocumentsUploaded && universityCertification && taxNumber
      );
    if (occupation === USERS_TYPES.FOREIGN_STUDENT)
      return (
        areIdentityDocumentsUploaded &&
        universityCertification &&
        residencyDocument
      );
    if (occupation === USERS_TYPES.SELF_EMPLOYED)
      return (
        areIdentityDocumentsUploaded &&
        bankAccountBalancePrepenultimate &&
        lastIncomeTaxReturn &&
        bankAccountBalancePenultimate &&
        bankAccountBalanceLatest &&
        secondLastIncomeTaxReturn &&
        taxNumber
      );
    if (occupation === USERS_TYPES.EMPLOYEE)
      return (
        areIdentityDocumentsUploaded &&
        workContract &&
        lastPaycheck &&
        secondLastPaycheck &&
        thirdLastPaycheck &&
        taxNumber
      );
    if (occupation === USERS_TYPES.UNEMPLOYED)
      return areIdentityDocumentsUploaded && taxNumber;
    if (
      occupation === USERS_TYPES.PENSIONER ||
      occupation === USERS_TYPES.RETIRED
    )
      return (
        areIdentityDocumentsUploaded &&
        lastPension &&
        secondLastPension &&
        taxNumber
      );
  };
  return areAllDocumentsUploaded() ? true : false;
};
